import { Box, Text } from '@chakra-ui/react';

interface IUserCard {
  roleName: string;
  description: string;
}

const OrganizationAccessCard = ({ roleName, description }: IUserCard) => (
  <Text fontSize='md'>
    <Box as='span' fontWeight='semibold'>
      {roleName}
    </Box>{' '}
    - {description}
  </Text>
);

export default OrganizationAccessCard;
